import { createSlice } from "@reduxjs/toolkit";
import { initialAlerts } from "../config/config.alerts";
// store alert messages generated by various application components
const alertSlice = createSlice({
  name: "alert",
  initialState: initialAlerts,
  reducers: {
    addAlert(state, action) {
      const { alertId, severity, message } = action.payload;
      if (state.alerts.find((alert) => alert.id === alertId) === undefined) {
        state.alerts = [...state.alerts, { id: alertId, severity, message }];
      }
    },
    removeAlert(state, action) {
      const alertId = action.payload;
      return {
        ...state,
        alerts: state.alerts.filter((a) => a.id !== alertId),
      };
    },
  },
});

export { alertSlice };
